import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { fromJS, List, Map } from 'immutable';
import { DocumentScheduleIntervalEnum } from '../../../document-data/document-data.data';
import { ISelectOption } from '../../../form-master/components/select-field/select-field.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';

@Injectable()
export class DocumentScheduleBuilder {
  constructor(private _translateService: TranslateService) {}

  buildDocumentScheduleOptions(hasFeature: boolean): List<ISelectOption> {
    const icon = {
      name: 'premium-feature',
      size: IconSizesEnum.small,
    };

    return List([
      {
        key: this._translateService.instant('DOCUMENT.INVOICE.RECURRING.OFF'),
        value: null,
        block: false,
      },
      {
        key: this._translateService.instant(
          'DOCUMENT.INVOICE.RECURRING.EVERY_WEEK'
        ),
        value: DocumentScheduleIntervalEnum.weekly,
        block: !hasFeature,
        icon: hasFeature ? null : icon,
      },
      {
        key: this._translateService.instant(
          'DOCUMENT.INVOICE.RECURRING.EVERY_TWO_WEEKS'
        ),
        value: DocumentScheduleIntervalEnum.fortnightly,
        block: !hasFeature,
        icon: hasFeature ? null : icon,
      },
      {
        key: this._translateService.instant(
          'DOCUMENT.INVOICE.RECURRING.EVERY_MONTH'
        ),
        value: DocumentScheduleIntervalEnum.monthly,
        block: !hasFeature,
        icon: hasFeature ? null : icon,
      },
    ]);
  }

  buildSchedulePayload(schedule: string, docDate: string): Map<string, any> {
    if (schedule === null) {
      return null;
    }

    return fromJS({
      doc_date: docDate,
      interval: schedule,
    });
  }
}
